import * as React from 'react';
import { Button as ButtonMui, Grid, IconButton as IconButtonMui } from '@mui/material';
import { Icon, Text } from '.';
import { textsize } from '../services/app.service';

interface Props {
  id?: string;
  label?: string;
  type?: any;
  color?: any;
  size?: textsize;
  sx?: any;
  startIcon?: string;
  endIcon?: string;
  textTransform?: 'none'|'capitalize'|'uppercase'|'lowercase';
  fullWidth?: boolean; 
  readOnly?: boolean;
  disablePadding?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
}

export const Button: React.FunctionComponent<Props> = (props) => {
  const color = props.type === 'contained'? 'white' : (props.color || 'primary.main');
  const sx = {
    bgcolor: props.type === 'contained' && (props.color || 'primary.main'), 
    border: props.type === 'outlined' && 1,
    borderColor: 'primary.light',
    borderRadius: '50%',
    boxShadow: props.type === 'contained' && 3,
    p: props.disablePadding? 0.2 : 1
  }
  const sxHover = {
    bgcolor: props.type === 'contained' ? 'primary.dark' : props.type === 'outlined' ? 'background.paper' : '', 
    border: props.type === 'outlined'? 1 : 0,
    borderColor: 'primary.main',
  }

  const icon = () => {
    if (props.startIcon)
      return (<Icon name={props.startIcon} color={color} size={props.size} /> )
  }

  return (
    <>
    {!props.label && !props.children?
      <IconButtonMui sx={{...props.sx, borderRadius: 50, borderColor: color, p: 0}} disabled={props.readOnly} onClick={props.onClick}>
        <Grid container sx={{...sx, ':hover': sxHover}} > 
          {icon()} 
        </Grid>
      </IconButtonMui>
    :
      <ButtonMui 
        id={props.id}
        component= {props.onClick? 'button' : 'label'}
        variant={props.type}
        color={props.color || 'primary'}
        startIcon={icon()}
        endIcon={props.endIcon? <Icon name= {props.endIcon} color={color} /> : ''}
        fullWidth={props.fullWidth}
        sx={{ borderRadius: 30, p: props.label && !props.disablePadding? 1 : 0, pl: props.label && !props.disablePadding? 2 : 0, pr: props.label && !props.disablePadding? 2 : 0, ...props.sx}}
        disabled={props.readOnly}
        onClick = {props.onClick}
      >
        {props.children}
        {props.label && <Text label={props.label} color={color} size={props.size} textAlign={props.sx?.textAlign || 'center'} sx={{textTransform: props.textTransform || 'capitalize'}} />}
      </ButtonMui>
    }
    </>
  );
}
